module.exports = __webpack_public_path__ + "static/media/large.adf26e7c.svg";